import React, {  } from 'react';


const SplashScreen = () => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-white z-50 text-indigo-500">
            <div className='w-40 h-40 animate-fade-loop'>Splashscreen...(logo)</div>
        </div>
    );
};

export default SplashScreen;
